// extracted by mini-css-extract-plugin
export var actionButton = "_ci-0";
export var attachmentLine = "_ci-1";
export var fileInput = "_ci-2";
export var fileUploadWrapper = "_ci-4";
export var footer = "_ci-3";
export var modalContent = "_ci-5";
export var paperclip = "_ci-6";
export var quillEditor = "_ci-7";